// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  stsAuthority: "https://login.microsoftonline.com/f610c0b7-bd24-4b39-810b-3dc280afb590/v2.0",
  clientId: "50577234-e77e-4adc-a320-5c5b475d63e9",
  ClientSecret : "agwN[.bk2aPzAQI@1mseN7cazGVweF8?",
  //clientRoot: 'http://localhost:4200/',
  //clientRoot: 'https://wem-dev.emro.who.int/KPIReports/',
  // clientRoot: 'https://aps-test2.emro.who.int/KPIReports/',
  
  clientRoot: 'https://kpireport.emro.who.int/KPIReports/',
  clientScope: 'Directory.Read.All User.Read User.ReadBasic.All openid profile api://50577234-e77e-4adc-a320-5c5b475d63e9/access-api',
  apiRoot: 'https://kpireport.emro.who.int/kpireportsapi/api/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
